<template>
    <StoryTab
        ref="storyTab"
        v-if="tab == 'story' || tab == 'story_share'"
        :tab="tab"
        :mode="mode"
        :files="files"
        :isFileUploading="isFileUploading"
        :hasFailedUpload="hasFailedUpload"
        :isSavingDraft="isSavingDraft"
        :dataFormRequest="dataFormRequest"
        :saveAllFormData="saveAllFormData"
        :formData="formData"
        :previewMode="previewMode"
        :idUsersAssigned="idUsersAssigned"
        :requiredValidation="requiredValidation"
        :canRestoreDraft="canRestoreDraft"
        :isMongoDraftEdit="isMongoDraftEdit"
        @assignUsers="assignUsers"
        @unassignCurrentUser="unassignCurrentUser"
        @addFile="uploadFile"
        @retryUploadFile="retryUploadFile"
        @discardFailedFile="discardFailedFile"
        @changeTab="changeTab"
        @generateFormData="generateFormData"
        @generateDataFormRequest="handlePreGenerateDataFormRequest"
        @saveDraft="saveDraft"
        @restoreFormData="restoreFormData"
        @saveFormData="saveFormData"
        @changePreviewDisplay="changePreviewDisplay"
        @sendPostAllPost="sendPostAllPost"
        @migratePageSaveInMainSave="migratePageSaveInMainSave"
        @retoreDraftInLocalStorage="retoreDraftInLocalStorage"
        @applyPostTemplate="applyPostTemplate"

    />

    <StandardTab
        ref="standardTab"
        v-else
        :mode="mode"
        :tab="tab"
        :files="files"
        :isFileUploading="isFileUploading"
        :hasFailedUpload="hasFailedUpload"
        :isSavingDraft="isSavingDraft"
        :dataFormRequest="dataFormRequest"
        :saveAllFormData="saveAllFormData"
        :formData="formData"
        :previewMode="previewMode"
        :requiredValidation="requiredValidation"
        :idUsersAssigned="idUsersAssigned"
        :canRestoreDraft="canRestoreDraft"
        :isMongoDraftEdit="isMongoDraftEdit"
        @assignUsers="assignUsers"
        @unassignCurrentUser="unassignCurrentUser"
        @addFile="uploadFile"
        @addExistingFiles="addTemplateFiles"
        @retryUploadFile="retryUploadFile"
        @discardFailedFile="discardFailedFile"
        @changeTab="changeTab"
        @generateFormData="generateFormData"
        @generateDataFormRequest="handlePreGenerateDataFormRequest"
        @saveDraft="saveDraft"
        @restoreFormData="restoreFormData"
        @saveFormData="saveFormData"
        @changePreviewDisplay="changePreviewDisplay"
        @sendPostAllPost="sendPostAllPost"
        @retoreDraftInLocalStorage="retoreDraftInLocalStorage"
        @personsIdentifiedRemoved="personsIdentifiedRemoved"
        @personsIdentifiedMigrated="personsIdentifiedMigrated"
        @applyBackgroundMediaResult="applyBackgroundMediaResult"
        @applyPostTemplate="applyPostTemplate"

    />
</template>

<script>
import { EventBus } from '@/event-bus';

import store from '@/store/index.js';
import StandardTab from '../postCreator/StandardTab.vue';
import StoryTab from '../postCreator/StoryTab.vue';

import { getInfoFile, getErrorNetworkFile, postNetworkValidator, matchesVideoOrigin } from './../postCreator/utils.js'
import { runPublishBranch } from './publishPost.js'
import { clarityEvent } from '@/utils/clarity'
import SSE from './../../../utils/sse.js'
import { withRetry } from './../../../utils/retryRequest.js'
import axios from 'axios';
import html2canvas from'html2canvas'
import * as Sentry from '@sentry/vue'

import postMixin from '@/components/mixins/Posts.vue'
import VideoMixin from '@/components/mixins/Video.vue'
import draftMixin from '@/components/mixins/Drafts.vue'
import BotsMixin from '@/components/mixins/Bots'
import CommonMixin from '@/components/mixins/Common'

import postCreatorMixin from './../postCreator/mixins/main.js'
import { formDataDefault, maxFilesPerNetwork, listNetworkSort } from './../postCreator/constante.js'
import Checkbox from '@/components/dash/utils/checkbox.vue';

import {
    findDifferences,
    mergeUpdates,
    deepClone,
} from './../postCreator/utils.js'

import { draftTemplate, editableNetworks } from './../postCreator/constante'

const MULTIPART_THRESHOLD_BYTES = 8 * 1024 * 1024
const MULTIPART_PART_SIZE_BYTES = 10 * 1024 * 1024
const MULTIPART_CONCURRENCY = 3
const STALL_TIMEOUT_SIMPLE_MS = 45000
const STALL_TIMEOUT_PART_MS = 30000
const LIGHT_REQUEST_TIMEOUT_MS = 30000

export default {

    mixins: [postMixin, draftMixin, postCreatorMixin, BotsMixin, CommonMixin, VideoMixin],

    components: {
        StandardTab,
        StoryTab,
        Checkbox
    },

    props: {
        mode: String,
    },

    data() {
        return {
            tab: 'standard',
            saveAllFormData:{
                main: {},
                networks: {},
                pages: {},
            },
            formData: JSON.parse(JSON.stringify(formDataDefault)),
            files:{},
            idFilesGeneratingInfo: [],
            dataFormRequest : {},
            previewMode: {
                active : false,
                pageSelected: null
            },
            dataEditPost: {},
            draft: {},
            draftNews: null,
            logs: [],
            idUsersAssigned: [],
            requiredValidation: true,
            // Never offer to restore a leftover real draft key inside the public demo - it's
            // meaningless here (nothing was ever really saved) and confusing for a visitor.
            canRestoreDraft: !this.$store.getters['demo/isActive'] && !!localStorage.getItem('postCreator/draftToRestore'),
            isSavingDraft: false,
        }
    },


    mounted() {
        console.log('mounted StandardTab.vue')
        this.$store.commit('selectPage/updateEnableAutoSave', false);
        EventBus.$on('postcreator/uploadFile', this.uploadFile);
        // Forced reload safety net, see router/index.js's router.onError
        EventBus.$on('postcreator/forceSaveDraftBeforeReload', this.autosaveDraftToRestore);
        window.addEventListener('beforeunload', this.autosaveDraftToRestore);
        this.loadMode()

        // Set by router.onError right before its own reload - skip the manual "restaurer" click
        if (sessionStorage.getItem('mashup_reload_restore_draft')) {
            sessionStorage.removeItem('mashup_reload_restore_draft')
            if (this.canRestoreDraft) this.retoreDraftInLocalStorage()
        }
    },

    methods: {
        changeTab(tabName) {
            if (!['standard', 'story','story_share'].includes(tabName)) return
            this.tab = tabName
            this.tabChosen = null
            this.$store.commit('selectPage/updateSelectPageStoryMode', tabName === 'story')
        },

        // Le guard du router recharge la sélection depuis le localStorage : on l'impose ici, après navigation
        preselectPage(pageId) {
            const apply = () => this.$store.commit('selectPage/updatePagesSelected', { saveToLocalStorage: false, pagesId: [pageId] })
            if (this.allPages[pageId]) return apply()
            const unwatch = this.$watch('allPages', pages => {
                if (!pages[pageId]) return
                unwatch()
                apply()
            })
        },

        loadMode() {
            let saveAllFormData = null; //permet de verifier la data
            this.draftNews = null // reset à chaque ouverture du PostCreator

            try {
                console.log('this.mode',this.mode)
                switch (this.mode) {
                    case 'edit':
                    case 'update': {

                        this.dataEditPost = this.$store.getters['postCreator/getDataEditPost'];
                        if (this.dataEditPost.draft && this.dataEditPost.draft.saveAllFormData && this.dataEditPost.draft.files) {
                            const draft = JSON.parse(JSON.stringify(this.dataEditPost.draft))
                            this.tab = draft.tab
                            this.idUsersAssigned = draft.idUsersAssigned || []
                            this.requiredValidation = draft.requiredValidation || false
                            this.files = draft.files
                            saveAllFormData = draft.saveAllFormData
                            this.logs = this.dataEditPost.post.page[0].log
                            //enlever de la section les pages déja publié, regarder dans saveAllFormData.page[id] ou dans saveAllFormData.networks[]

                            this.$store.commit('selectPage/updatePagesSelected', {saveToLocalStorage: false, pagesId: this.dataEditPost.posts.reduce((newSelection, post)=> (this.allPages[post.page] && newSelection.push(post.page), newSelection), [])});
                            if (this.mode == "update") EventBus.$emit('selectPageSection/freezeSelectPage', true);
                            
                            EventBus.$on('postcreator/deletePostFromClickSelectPage', this.deletePostFromClickSelectPage);
                        }else{
                            throw new Error("Edition impossible");
                        }
                        break;
                    }

                    case 'duplicate': {
                        const dataDuplicatePost = this.$store.getters['postCreator/getDataDuplicatePost'];
                        if(dataDuplicatePost && dataDuplicatePost.excludeNews) {
                            this.dataEditPost.excludeNews = dataDuplicatePost.excludeNews
                        }
                        if (dataDuplicatePost.draft && dataDuplicatePost.draft.saveAllFormData && dataDuplicatePost.draft.files) {
                            this.tab = dataDuplicatePost.draft.tab
                            this.files = dataDuplicatePost.draft.files
                            saveAllFormData = dataDuplicatePost.draft.saveAllFormData
                            this.$store.commit('selectPage/updatePagesSelected', {saveToLocalStorage: false, pagesId: dataDuplicatePost.pages.reduce((availablePages, pageId)=> (this.allPages[pageId] && availablePages.push(pageId), availablePages), [])});
                        }else{                                                            
                            throw new Error("Duplication impossible");
                        }
                        break;
                    }
                    case 'draft': {
                    
                        this.draft = this.$store.getters['postCreator/getDataDraft'];

                        if (this.draft.id && this.draft.data.saveAllFormData && this.draft.data.files) {
                            const draft = JSON.parse(JSON.stringify(this.draft))
                            this.tab = draft.data.tab
                            this.idUsersAssigned = draft.data.idUsersAssigned || []
                            this.requiredValidation = draft.data.requiredValidation || false
                            this.files = draft.data.files
                            saveAllFormData =  draft.data.saveAllFormData
                            this.logs = draft.data.log || []
                            this.$store.commit('selectPage/updatePagesSelected', {saveToLocalStorage: false, pagesId: draft.data.pages.reduce((availablePages, pageId)=> (this.allPages[pageId] && availablePages.push(pageId), availablePages), [])});
            
                        }else{
                            throw new Error("Impossible de charger le draft");
                        }
                        break;
                    }
                    case 'create': {
                        if (this.$route.query.scheduleDate) {
                        
                            const scheduleDate = new Date(this.$route.query.scheduleDate)
                            console.log("clem", this.$route.query.scheduleDate,  scheduleDate.toLocaleDateString('sv'))
                            this.formData.planifiedDate = {
                                date: scheduleDate.toLocaleDateString('sv') ,
                                hours:`${String(scheduleDate.getHours()).padStart(2, '0')}:${String(scheduleDate.getMinutes()).padStart(2, '0')}`,
                                timestamp: scheduleDate.getTime()
                            }
                        
                        }
                        this.idUsersAssigned = this.getAssignUserLocalStorage()
                        // Page imposée par l'appelant (ex. overview) via params du router : sélection non sauvegardée
                        if (this.$route.params.pageId) this.preselectPage(String(this.$route.params.pageId))
                        break;
                    }
                    default: {
                        throw new Error("Impossible de charger le mode");
                    }
                        
                }

                if (saveAllFormData) {
                    this.applyLoadedFormData(saveAllFormData)
                }

            } catch (error) {
                console.error(error)
                if (['edit', 'update'].includes(this.mode)) {
                    this.addLog(this.currentUser, 'edit-post-load-failed', {
                        error: error.message,
                        stack: error.stack,
                        mode: this.mode,
                        postId: this.dataEditPost?.post?.id,
                        pagePostIds: this.dataEditPost?.posts?.map(post => post._id),
                    })
                    this.$vs.notify({
                        title: this.$t('dash.notifications.error_title'),
                        text: this.$t('dash.post-creator.request.edit-load-failed'),
                        color: 'danger',
                    })
                }
                this.$router.push('/dash/postCreator');
        }
        },

        applyLoadedFormData(saveAllFormData) {
            if (this.mode !== 'update') {
                // Synchrone version of forEeachSaveAllFormdata
                const resetStalePlanifiedDate = (formData, isMain) => {
                    if (formData.planifiedDate && formData.planifiedDate.date) {
                        const timestamp = formData.planifiedDate.timestamp || new Date(`${formData.planifiedDate.date}T${(formData.planifiedDate.hours || '00:00').replace('h', ':')}:00`).getTime()
                        if (timestamp < Date.now()) {
                            if (isMain) {
                                formData.planifiedDate = {
                                    date: false,
                                    hours: false,
                                    timestamp: false
                                }
                            }else{
                                delete formData.planifiedDate
                            }
                        }
                    }
                }
                if (saveAllFormData.main) resetStalePlanifiedDate(saveAllFormData.main, true)
                Object.values(saveAllFormData.networks || {}).forEach(formData => resetStalePlanifiedDate(formData, false))
                Object.values(saveAllFormData.pages || {}).forEach(formData => resetStalePlanifiedDate(formData, false))
            }
            this.saveAllFormData = saveAllFormData
            this.formData = saveAllFormData.main
        },

        // applies a 'post' template (see TemplatePicker.vue) — only ever triggered while
        // mode === 'create' (button is hidden otherwise). Deep-clones the template's data so
        // editing the new post never mutates the stored template (kept in the Vuex templates
        // store by reference) — the same class of bug as the un-cloned dataDuplicatePost.
        applyPostTemplate(template) {
            if (!template || !template.data || !template.data.saveAllFormData || !template.data.files) return

            const data = JSON.parse(JSON.stringify(template.data))

            if (data.tab) this.tab = data.tab
            this.files = data.files
            // anciens modèles sans pages, ou pages plus accessibles : on garde la sélection courante
            const templatePages = (data.pages || []).filter(pageId => this.allPages[pageId])
            if (templatePages.length) this.$store.commit('selectPage/updatePagesSelected', {saveToLocalStorage: false, pagesId: templatePages})
            this.applyLoadedFormData(data.saveAllFormData)
        },

        async uploadFile(cbFinish, files, uplaodInstantly = false, idFiles, cbFinshLocal) {
            let ids = []
            try {
                const fileMultiple = files instanceof FileList || Array.isArray(files)

                if (files instanceof FileList) {
                    files = Array.from(files);
                } else if (!Array.isArray(files)) {
                    files = [files]
                }

                if (idFiles && !Array.isArray(idFiles)) idFiles = [idFiles]

                ids = files.map((file, index) => idFiles && idFiles[index] ? idFiles[index] : Math.random().toString(36).substr(2, 9))
                this.idFilesGeneratingInfo = [...this.idFilesGeneratingInfo, ...ids]


                const promises = []


                for (let index = 0; index < files.length; index++) {
                    const file = files[index];
                    
                    console.log("uploadFile file", file)
                    let idFile = ids[index]

                    if (this.files[idFile] && (uplaodInstantly == false || this.files[idFile].isUpload)) {
                        this.idFilesGeneratingInfo = this.idFilesGeneratingInfo.filter(id => !ids.includes(id))
                        return this.files[idFile];
                    }

                    //if arg file is url blob else convert file
                    if (typeof file === "string" && (file.startsWith("blob:") || file.startsWith("http"))) {
                        try {
                            const response = await fetch(file);
                            const blob = await response.blob();
                            file = new File([blob], "image.jpg", { type: blob.type });
                            console.log("file from url blob", file)
                        } catch (error) {
                            console.error("Erreur de téléchargement (CORS probable) :", error);
                            this.idFilesGeneratingInfo = this.idFilesGeneratingInfo.filter(id => !ids.includes(id))
                            return
                        }
                   
                    }

                    let url, info, errorNetwork;
                    if (this.files[idFile]) {
                        url = this.files[idFile].url;
                        info = this.files[idFile].info;
                        errorNetwork = this.files[idFile].errorNetwork;
                    } else {
                        url = URL.createObjectURL(file);
                        info = await getInfoFile(file, url);
                        errorNetwork = getErrorNetworkFile({info});
                    }
                    console.log("info", info, errorNetwork)
                    const fileData = {
                        id: idFile,
                        url,
                        localFile: file,
                        info,
                        errorNetwork: errorNetwork,
                        normalizedNetworks: {},
                        isUpload: false,
                        failedUpload: false,
                        uploadProgress: uplaodInstantly,
                        percentUpload: 0,
                        isNormalizing: false
                    };

                
                    if (!this.files[idFile]) {
                        this.$set(this.files, idFile, fileData);
                    }
                

                    if (index == files.length - 1) {
                        this.addLog(this.currentUser, `upload-file-check-1`, {
                            idFiles,
                            lengthFiles: files.length,
                            index,
                            filesManager: this.files
                        })
                        if (cbFinshLocal) cbFinshLocal();      
                    }

                    this.idFilesGeneratingInfo = this.idFilesGeneratingInfo.filter(id => id !== idFile)
                    if (!uplaodInstantly) {
                    
                        return this.files[idFile];
                    }
                
                    promises[index] = () => this.attemptFileUpload(idFile, file, info);
                };
            
                const results = [];

                for (const promise of promises) {
                    const result = await promise();
                    results.push(result);
                }
                console.log('results',results)
                if (cbFinish) cbFinish(fileMultiple ? results : results[0]);        
            } catch (error) {
                console.error('Erreur lors de l\'upload du fichier :', error);
                Sentry.captureException(error);
                ids.forEach(id => {
                    this.idFilesGeneratingInfo = this.idFilesGeneratingInfo.filter(i => i !== id)
                    if (this.files[id] && !this.files[id].isUpload) {
                        this.$set(this.files[id], 'uploadProgress', false);
                        this.$set(this.files[id], 'failedUpload', true);
                    }
                })
                this.addLog(this.currentUser, `upload-file-error`, {
                    payload: {
                        idFiles,
                        error: error.message,
                    }
                })

            }

            this.addLog(this.currentUser, `upload-file-check-2`, {
                idFiles,
                filesManager: this.files
            })
        },

        // Applying a media template: files are already hosted on S3 (see MediaTemplateUploader.vue),
        // so unlike uploadFile() above this must NOT go through fetch()+re-upload - that fetch() of
        // an S3 url is exactly what was throwing "Erreur de téléchargement (CORS probable)" when a
        // media template with several files was applied from the post creator. Registers the files
        // as already-uploaded directly, then best-effort probes width/height/duration.
        addTemplateFiles(files, ids, cb) {
            files.forEach((f, index) => {
                const idFile = ids[index]
                if (this.files[idFile]) return

                const mimetype = f.mimetype || ''
                const type2 = ['image', 'video'].includes(mimetype.split('/')[0])
                    ? mimetype.split('/')[0]
                    : mimetype === 'application/pdf' ? 'pdf' : undefined

                const info = {
                    name: f.name || (f.url || '').split('/').pop(),
                    size: f.size,
                    type: mimetype,
                    type2,
                    width: undefined,
                    height: undefined,
                    aspectRatio: undefined,
                    framesLength: undefined,
                    averageColor: undefined,
                    enclosure: mimetype.startsWith('image/') ? f.url : undefined
                }

                this.$set(this.files, idFile, {
                    id: idFile,
                    url: f.url,
                    localFile: null,
                    info,
                    errorNetwork: getErrorNetworkFile({ info }),
                    normalizedNetworks: {},
                    isUpload: true,
                    failedUpload: false,
                    uploadProgress: false,
                    percentUpload: 100,
                    isNormalizing: false
                })

                this.probeTemplateFileDimensions(idFile, f.url, mimetype)
                // Videos never go through compressMedia() here, which is what normally sets their
                // enclosure - without it a post whose first media comes from a template has no preview.
                if (mimetype.startsWith('video/')) this.fetchVideoThumbnail(idFile)
            })

            if (cb) cb()
        },

        // <img>/<video> metadata reads (naturalWidth/videoWidth/duration) don't require CORS,
        // unlike fetch() or canvas pixel access - safe against the same S3 CORS wall addTemplateFiles
        // avoids above.
        probeTemplateFileDimensions(idFile, url, mimetype) {
            if (mimetype.startsWith('image/')) {
                const img = new Image()
                img.onload = () => {
                    if (!this.files[idFile]) return
                    this.$set(this.files[idFile].info, 'width', img.width)
                    this.$set(this.files[idFile].info, 'height', img.height)
                    this.$set(this.files[idFile].info, 'aspectRatio', img.width / img.height)
                }
                img.src = url
            } else if (mimetype.startsWith('video/')) {
                const video = document.createElement('video')
                video.preload = 'metadata'
                video.muted = true
                video.onloadedmetadata = () => {
                    if (!this.files[idFile]) return
                    this.$set(this.files[idFile].info, 'width', video.videoWidth)
                    this.$set(this.files[idFile].info, 'height', video.videoHeight)
                    this.$set(this.files[idFile].info, 'aspectRatio', video.videoWidth / video.videoHeight)
                    this.$set(this.files[idFile].info, 'duration', video.duration)
                }
                video.src = url
            }
        },

        attemptFileUpload(idFile, file, info) {
            // Demo (DemoPostCreator.vue): never touch the real upload/compress backend - it needs
            // a real Bearer token (and compressMedia/compressMediaByNetwork need a real, fetchable
            // HTTP url anyway, which a blob: url isn't). The file this.files[idFile].url already
            // points to (set in uploadFile(), via URL.createObjectURL) is used as-is - the visitor's
            // own picture never leaves their browser, no upload happens at all.
            if (this.isDemo) {
                this.$set(this.files, idFile, {
                    ...this.files[idFile],
                    isUpload: true,
                    failedUpload: false,
                    uploadProgress: false,
                    percentUpload: 100,
                })
                this.$set(this.files[idFile], 'errorNetwork', getErrorNetworkFile(this.files[idFile]))
                return Promise.resolve(this.files[idFile])
            }

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const uploadResult = file.size >= MULTIPART_THRESHOLD_BYTES
                            ? await this.uploadFileMultipart(idFile, file, info)
                            : await this.uploadFileSimple(idFile, file, info)

                        if (uploadResult) {
                            await this.finalizeUpload(idFile, uploadResult.urlFinal)
                            resolve(this.files[idFile])
                            return
                        }

                        // Pas d'URL S3 disponible (décision métier, pas une erreur réseau) : fallback service vidéo
                        const formData = new FormData();
                        formData.append('file', file);
                        const userId = JSON.parse(localStorage.user).id;
                        const source = new SSE(
                            `${process.env.VUE_APP_VIDEO_API_HOST}/image/progress?u=${userId}`,
                            { payload: formData }
                        );

                        let stallTimer
                        const resetStallTimer = () => {
                            clearTimeout(stallTimer)
                            stallTimer = setTimeout(() => {
                                source.close()
                                reject(new Error('Upload bloqué : aucune progression reçue'))
                            }, STALL_TIMEOUT_SIMPLE_MS)
                        }
                        resetStallTimer()

                        source.onopen = () => {
                            this.$set(this.files[idFile], 'percentUpload', 1);
                            resetStallTimer()
                        };

                        source.onerror = (err) => {
                            clearTimeout(stallTimer)
                            // source.close() dans onmessage (upload réussi) peut déclencher un 'error' tardif
                            // sur la connexion en cours de fermeture : ne pas écraser un upload déjà finalisé.
                            if (this.files[idFile] && !this.files[idFile].isUpload) {
                                this.$set(this.files[idFile], 'uploadProgress', false);
                                this.$set(this.files[idFile], 'failedUpload', true);
                            }
                            reject(err);
                        };

                        source.onmessage = async(event) => {
                            resetStallTimer()
                            let response = JSON.parse(event.data);

                            if (response.file_url) {
                                clearTimeout(stallTimer)
                                source.close();
                                try {
                                    await new Promise(r => setTimeout(r, 500))
                                    await this.finalizeUpload(idFile, response.file_url)
                                    resolve(this.files[idFile]);
                                } catch (error) {
                                    if (this.files[idFile] && !this.files[idFile].isUpload) {
                                        this.$set(this.files[idFile], 'uploadProgress', false);
                                        this.$set(this.files[idFile], 'failedUpload', true);
                                    }
                                    reject(error);
                                }
                            } else if (response.percent) {
                                this.$set(this.files[idFile], 'percentUpload', response.percent);
                            } else if (response.error) {
                                clearTimeout(stallTimer)
                                source.close();
                                if (this.files[idFile] && !this.files[idFile].isUpload) {
                                    this.$set(this.files[idFile], 'uploadProgress', false);
                                    this.$set(this.files[idFile], 'failedUpload', response.error);
                                }
                                reject(new Error(response.error));
                            }

                        };
                        source.stream((progress) => progress.lengthComputable && this.$set(this.files[idFile], 'percentUpload', (progress.loaded / progress.total) * 100));
                    } catch (error) {
                        if (this.files[idFile] && !this.files[idFile].isUpload) {
                            this.$set(this.files[idFile], 'uploadProgress', false);
                            this.$set(this.files[idFile], 'failedUpload', true);
                        }
                        reject(error);
                    }
                })()
            })
        },

        async retryUploadFile(idFile) {
            const file = this.files[idFile]
            if (!file || !file.failedUpload || !file.localFile || file.uploadProgress) return

            this.$set(this.files[idFile], 'failedUpload', false)
            this.$set(this.files[idFile], 'uploadProgress', true)
            this.$set(this.files[idFile], 'percentUpload', 0)

            try {
                await this.attemptFileUpload(idFile, file.localFile, file.info)
            } catch (error) {
                console.error('Erreur lors de la relance de l\'upload du fichier :', error)
                Sentry.captureException(error)
            }
        },

        discardFailedFile(idFile) {
            if (this.files[idFile] && this.files[idFile].failedUpload) {
                this.$delete(this.files, idFile)
            }
        },

        normalizeFileNameForUpload(name) {
            const [base, ...rest] = name.split('.');
            const ext = rest.length ? '.' + rest.pop() : '';
            const safeBase = base
                .normalize('NFKD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9._-]+/g, '-')
                .replace(/^-+|-+$/g, '')
                .toLowerCase();
            return (safeBase || 'file') + ext.toLowerCase();
        },

        async getUploadUrlStrict(fileName, fileType, { multipart } = {}) {
            const params = new URLSearchParams({ fileName: this.normalizeFileNameForUpload(fileName), fileType })
            if (multipart) params.set('multipart', 'true')
            const { data } = await axios.get(`${process.env.VUE_APP_API_HOST}/tools/get-upload-url?${params.toString()}`, {
                timeout: LIGHT_REQUEST_TIMEOUT_MS,
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            })
            return data
        },

        async getMultipartPartUrls(key, uploadId, partCount) {
            const params = new URLSearchParams({ key, uploadId, partCount })
            const { data } = await axios.get(`${process.env.VUE_APP_API_HOST}/tools/get-multipart-part-urls?${params.toString()}`, {
                timeout: LIGHT_REQUEST_TIMEOUT_MS,
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            })
            return data.parts
        },

        async completeMultipartUpload(key, uploadId, parts) {
            const { data } = await axios.post(`${process.env.VUE_APP_API_HOST}/tools/complete-multipart-upload`, { key, uploadId, parts }, {
                timeout: LIGHT_REQUEST_TIMEOUT_MS,
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            })
            return data
        },

        async abortMultipartUpload(key, uploadId) {
            try {
                await axios.post(`${process.env.VUE_APP_API_HOST}/tools/abort-multipart-upload`, { key, uploadId }, {
                    timeout: LIGHT_REQUEST_TIMEOUT_MS,
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                })
            } catch (error) {
                console.error('Erreur lors de l\'abandon du multipart upload S3 :', error)
            }
        },

        async putWithStallTimeout(url, body, contentType, onProgress, stallTimeoutMs) {
            const controller = new AbortController()
            let stallTimer
            const resetStallTimer = () => {
                clearTimeout(stallTimer)
                stallTimer = setTimeout(() => controller.abort(), stallTimeoutMs)
            }
            resetStallTimer()

            if (!contentType) {
                // Parties multipart : l'API S3 UploadPart ne supporte pas ContentType (le SDK le rejette même à la
                // signature), l'URL présignée est donc signée avec un Content-Type vide. axios ajoute toujours un
                // Content-Type par défaut (application/x-www-form-urlencoded) qu'on n'arrive pas à supprimer de façon
                // fiable -> XHR brut, qui ne fixe aucun Content-Type tant qu'on ne l'appelle pas explicitement et
                // qui expose upload.onprogress (contrairement à fetch) pour un vrai reset du minuteur de blocage.
                return new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest()
                    xhr.open('PUT', url)
                    controller.signal.addEventListener('abort', () => xhr.abort())
                    xhr.upload.onprogress = (event) => {
                        resetStallTimer()
                        if (onProgress) onProgress(event)
                    }
                    xhr.onload = () => {
                        clearTimeout(stallTimer)
                        if (xhr.status >= 200 && xhr.status < 300) {
                            resolve({ headers: { etag: xhr.getResponseHeader('etag') } })
                        } else {
                            const error = new Error(`Echec upload partie S3 (status ${xhr.status})`)
                            error.response = { status: xhr.status }
                            reject(error)
                        }
                    }
                    xhr.onerror = () => {
                        clearTimeout(stallTimer)
                        reject(new Error('Erreur réseau lors de l\'upload de la partie'))
                    }
                    xhr.onabort = () => {
                        clearTimeout(stallTimer)
                        reject(new Error('Upload de partie interrompu (blocage ou déconnexion)'))
                    }
                    xhr.send(body)
                })
            }

            try {
                return await axios.put(url, body, {
                    headers: { 'Content-Type': contentType },
                    signal: controller.signal,
                    onUploadProgress: (progressEvent) => {
                        resetStallTimer()
                        if (onProgress) onProgress(progressEvent)
                    }
                })
            } finally {
                clearTimeout(stallTimer)
            }
        },

        async finalizeUpload(idFile, urlFinal) {
            this.$set(this.files[idFile], 'url', urlFinal);
            await this.compressMedia(idFile)
            this.$set(this.files, idFile, {
                ...this.files[idFile],
                isUpload: true,
                failedUpload: false,
                uploadProgress: false,
                percentUpload: 100,
            });
            await this.compressMediaByNetwork(idFile)
            this.$set(this.files[idFile], 'errorNetwork', getErrorNetworkFile(this.files[idFile]));
        },

        // Fichier < MULTIPART_THRESHOLD_BYTES : PUT unique, retry avec backoff, URL fraîche à chaque tentative
        async uploadFileSimple(idFile, file, info) {
            return withRetry(async () => {
                const uploadUrl = await this.getUploadUrlStrict(info.name, info.type)
                if (!uploadUrl?.uploadURL || !uploadUrl?.urlFinal) return null

                await this.putWithStallTimeout(uploadUrl.uploadURL, file, info.type, (progressEvent) => {
                    const percentProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    this.$set(this.files[idFile], 'percentUpload', percentProgress);
                }, STALL_TIMEOUT_SIMPLE_MS)

                return { urlFinal: uploadUrl.urlFinal }
            }, {
                retries: 3,
                onRetry: (attempt, error) => {
                    Sentry.addBreadcrumb({ category: 'upload', level: 'warning', message: `S3 upload retry #${attempt}`, data: { fileId: idFile, fileName: info.name, error: error?.message } })
                }
            })
        },

        // Fichier >= MULTIPART_THRESHOLD_BYTES : multipart S3, retry par partie (pas de reprise à 0)
        async uploadFileMultipart(idFile, file, info) {
            const uploadUrlData = await withRetry(() => this.getUploadUrlStrict(info.name, info.type, { multipart: true }), {
                retries: 3,
                onRetry: (attempt, error) => {
                    Sentry.addBreadcrumb({ category: 'upload', level: 'warning', message: `Initiation multipart retry #${attempt}`, data: { fileId: idFile, fileName: info.name, error: error?.message } })
                }
            })
            if (!uploadUrlData?.multipart || !uploadUrlData?.uploadId) return null

            const { uploadId, key, urlFinal } = uploadUrlData
            const partCount = Math.ceil(file.size / MULTIPART_PART_SIZE_BYTES)
            const partUrls = await withRetry(() => this.getMultipartPartUrls(key, uploadId, partCount), {
                retries: 3,
                onRetry: (attempt, error) => {
                    Sentry.addBreadcrumb({ category: 'upload', level: 'warning', message: `getMultipartPartUrls retry #${attempt}`, data: { fileId: idFile, fileName: info.name, error: error?.message } })
                }
            })

            const partBytesLoaded = {}
            const updateAggregateProgress = () => {
                const loaded = Object.values(partBytesLoaded).reduce((sum, n) => sum + n, 0)
                this.$set(this.files[idFile], 'percentUpload', Math.min(99, Math.round((loaded * 100) / file.size)));
            }

            const completedParts = []

            const uploadPart = async (partNumber, url) => {
                const start = (partNumber - 1) * MULTIPART_PART_SIZE_BYTES
                const end = Math.min(start + MULTIPART_PART_SIZE_BYTES, file.size)
                // type: '' pour éviter que le navigateur ajoute un Content-Type non signé (uploadPart n'a pas de ContentType côté S3)
                const chunk = file.slice(start, end, '')

                const response = await withRetry(() => {
                    partBytesLoaded[partNumber] = 0
                    return this.putWithStallTimeout(url, chunk, null, (progressEvent) => {
                        partBytesLoaded[partNumber] = progressEvent.loaded
                        updateAggregateProgress()
                    }, STALL_TIMEOUT_PART_MS)
                }, {
                    retries: 3,
                    onRetry: (attempt, error) => {
                        partBytesLoaded[partNumber] = 0
                        updateAggregateProgress()
                        Sentry.addBreadcrumb({ category: 'upload', level: 'warning', message: `S3 multipart part retry #${attempt}`, data: { fileId: idFile, fileName: info.name, partNumber, error: error?.message } })
                    }
                })

                partBytesLoaded[partNumber] = end - start
                updateAggregateProgress()
                completedParts.push({ PartNumber: partNumber, ETag: response.headers.etag })
            }

            try {
                const queue = [...partUrls]
                while (queue.length) {
                    const batch = queue.splice(0, MULTIPART_CONCURRENCY)
                    await Promise.all(batch.map(p => uploadPart(p.partNumber, p.url)))
                }
            } catch (error) {
                await this.abortMultipartUpload(key, uploadId)
                throw error
            }

            completedParts.sort((a, b) => a.PartNumber - b.PartNumber)
            await this.completeMultipartUpload(key, uploadId, completedParts)
            return { urlFinal }
        },

        generateFormData(pageOrNetwork = null) {
            
            console.log('generateFormData 1',pageOrNetwork)
            let formDataRef = deepClone(this.saveAllFormData.main)
            if (pageOrNetwork) {
                if(typeof pageOrNetwork === 'object' && pageOrNetwork.id){
                    //page
                    if (this.saveAllFormData.networks[pageOrNetwork.network]) mergeUpdates(formDataRef,this.saveAllFormData.networks[pageOrNetwork.network])
                    if (this.saveAllFormData.pages[pageOrNetwork.id]) mergeUpdates(formDataRef,this.saveAllFormData.pages[pageOrNetwork.id])
                }else {
                    //network
                    mergeUpdates(formDataRef,this.saveAllFormData.networks[pageOrNetwork])
                }
            }
            this.formData = formDataRef
        },

        // Video multi-personalization (StandardTab.vue) - an export finishing for a scope OTHER
        // than the one currently on screen can't touch the live this.formData (it reflects
        // whichever scope IS on screen right now, not necessarily this one) - it has to patch
        // that scope's own saveAllFormData entry directly. Mirrors the same network->page
        // override resolution generateFormData(pageOrNetwork) already applies, without calling
        // generateFormData itself (which would replace this.formData with the wrong scope).
        applyBackgroundMediaResult({ scopeKey, fileIdOrigin, buildNewEntry, storyId }) {
            // Story mode has no general/page/network scoping (a single FormStory instance, always
            // scopeKey 'story' - see FormStory.vue's getPendingMediaExportSessionsInfo) and stores
            // its background media at a different path entirely (formData.storification, not
            // .files) - same reasoning as the 'general' branch below (a background scope can't
            // touch the live this.formData, which may belong to a different story/page by the time
            // this runs), just against saveAllFormData.main.storification[storyId].background
            // instead of saveAllFormData.main.files.
            if (scopeKey === 'story') {
                const stories = this.saveAllFormData.main.storification
                if (!stories[storyId]) this.$set(stories, storyId, {})
                const target = stories[storyId]
                const newEntry = buildNewEntry()
                this.$set(target, 'background', { ...(target.background || {}), file: newEntry })

                // A page/network personalization can hold its OWN stale snapshot of this exact story
                // (saveFormData copies the whole storification object into these overrides whenever
                // something on that scope is customized - unrelated to this background specifically).
                // generateDataFormRequest's mergeUpdates recursively merges page/network overrides
                // OVER saveAllFormData.main field-by-field (see mergeUpdates in utils.js) - a stale
                // override's background.file.id silently wins over the fresh one just set above,
                // reintroducing the pre-edit file. Scrub every override still pointing at the old
                // file, same fileIdOrigin match the page/network branches below already use.
                const patchStaleOverride = (scopeObj) => {
                    const story = scopeObj && scopeObj.storification && scopeObj.storification[storyId]
                    const staleFile = story && story.background && story.background.file
                    if (staleFile && matchesVideoOrigin(staleFile, fileIdOrigin)) {
                        this.$set(story.background, 'file', newEntry)
                    }
                }
                Object.values(this.saveAllFormData.pages || {}).forEach(patchStaleOverride)
                Object.values(this.saveAllFormData.networks || {}).forEach(patchStaleOverride)
                return
            }

            const [kind, id] = scopeKey.split(':')

            if (kind === 'general') {
                const files = (this.saveAllFormData.main.files || []).map(f => matchesVideoOrigin(f, fileIdOrigin) ? buildNewEntry(f) : f)
                this.$set(this.saveAllFormData.main, 'files', files)
                return
            }

            let files = this.saveAllFormData.main.files || []
            const network = kind === 'network' ? id : (this.allPages[id] && this.allPages[id].network)
            if (network && this.saveAllFormData.networks[network] && this.saveAllFormData.networks[network].files) {
                files = this.saveAllFormData.networks[network].files
            }
            const target = kind === 'network' ? this.saveAllFormData.networks : this.saveAllFormData.pages
            if (kind === 'page' && target[id] && target[id].files) {
                files = target[id].files
            }

            // Matched by fileIdOrigin (stable across re-encodes), not a transient id - `files` here
            // can be a FALLBACK array inherited from a scope this session doesn't own (main/network),
            // and a sibling scope (e.g. general) concluding first can already have replaced that exact
            // id in that same shared array by the time this runs - matching by id would then silently
            // find nothing and drop this scope's edit entirely. See matchesVideoOrigin in utils.js.
            const updatedFiles = files.map(f => matchesVideoOrigin(f, fileIdOrigin) ? buildNewEntry(f) : f)
            if (!target[id]) this.$set(target, id, {})
            this.$set(target[id], 'files', updatedFiles)
        },

        restoreFormData(path, pageOrNetwork) {
            console.log("test12 restoreFormData",path, pageOrNetwork)
            if (!pageOrNetwork || !path) return

            if (!Array.isArray(path)) path = [path]
  
            if(typeof pageOrNetwork === 'object' && pageOrNetwork.id){
                //est une page
                if (this.saveAllFormData.pages[pageOrNetwork.id]) {
                    this.$delete(
                        [pageOrNetwork.id, ...path].slice(0,-1).reduce((acc, key) => acc[key], this.saveAllFormData.pages), 
                        path.slice(-1)[0]
                    )
                } this.$delete(this.saveAllFormData.pages[pageOrNetwork.id], path)
            }else{
                //est un network
                if (this.saveAllFormData.networks[pageOrNetwork]) {
                    this.$delete(
                        [pageOrNetwork, ...path].slice(0,-1).reduce((acc, key) => acc[key], this.saveAllFormData.networks), 
                        path.slice(-1)[0]
                    )
                }
            }    

            this.generateFormData(pageOrNetwork)    
        },

        saveFormData(pageOrNetwork) {
            console.log("test12 saveFormData", 'start', pageOrNetwork)
            if (!pageOrNetwork) {
                this.$set(this.saveAllFormData, 'main', deepClone(this.formData))
            }else{
                let formDataRef = deepClone(this.saveAllFormData.main)
                if(typeof pageOrNetwork === 'object' && pageOrNetwork.id){
                     // pageOrNetwork est une page
                    if (this.saveAllFormData.networks[pageOrNetwork.network]) mergeUpdates(formDataRef, this.saveAllFormData.networks[pageOrNetwork.network])
                    const update = findDifferences(formDataRef, this.formData)
                    this.$set(this.saveAllFormData.pages, pageOrNetwork.id, update)
                } else {
                    // pageOrNetwork est un network
                    const update = findDifferences(formDataRef, this.formData)
                    this.$set(this.saveAllFormData.networks, pageOrNetwork, update)
                } 
            }
            console.log("test12 saveFormData", 'end')
        },

        // scopes qui héritent réellement ce fichier du scope édité (pageOrNetwork, même convention que saveFormData) sans avoir leur propre liste de fichiers :
        // main peut affecter des réseaux/pages, un réseau peut affecter ses pages, une page n'affecte jamais rien d'autre (scope feuille)
        getImpactedPersonsIdentifiedScopes(pageOrNetwork) {
            if (pageOrNetwork && typeof pageOrNetwork === 'object' && pageOrNetwork.id) return []

            const scopes = []

            if (!pageOrNetwork) {
                Object.values(this.saveAllFormData.networks).forEach(networkOverride => {
                    if (!networkOverride.files) scopes.push(networkOverride)
                })
            }

            Object.entries(this.saveAllFormData.pages).forEach(([pageId, pageOverride]) => {
                if (pageOverride.files) return // la page a ses propres fichiers : non affectée
                const page = this.allPages[pageId]
                if (!page) return
                if (pageOrNetwork && page.network !== pageOrNetwork) return // pas dans le réseau édité
                if (!pageOrNetwork && this.saveAllFormData.networks[page.network]?.files) return // la page hérite des fichiers de son réseau, pas de main
                scopes.push(pageOverride)
            })

            return scopes
        },

        personsIdentifiedRemoved(id, pageOrNetwork) {
            this.getImpactedPersonsIdentifiedScopes(pageOrNetwork).forEach(scope => {
                if (scope.formDataNetwork?.instagram?.personsIdentified?.length) {
                    this.$set(scope.formDataNetwork.instagram, 'personsIdentified', scope.formDataNetwork.instagram.personsIdentified.filter(p => p.idFile !== id))
                }
            })
        },

        personsIdentifiedMigrated({oldId, newId}, pageOrNetwork) {
            this.getImpactedPersonsIdentifiedScopes(pageOrNetwork).forEach(scope => {
                if (scope.formDataNetwork?.instagram?.personsIdentified?.length) {
                    this.$set(scope.formDataNetwork.instagram, 'personsIdentified', scope.formDataNetwork.instagram.personsIdentified.map(p => p.idFile === oldId ? {...p, idFile: newId} : p))
                }
            })
        },

        migratePageSaveInMainSave(pageId) {
            /*Migre l'ensembe des modifications de la page dans la save main*/
            /* Si une highlight est definie dans un story alors la laisser dans la save de la page */

            if (!this.saveAllFormData.pages[pageId]) return

            const formDataPage = deepClone(this.saveAllFormData.pages[pageId])

            const newFormDataPage = {}

            //Récupérer les highlights et le retirer de la save
            if (formDataPage.storification && Object.keys(formDataPage.storification).length) {
                for (const [storyId, story] of Object.entries(formDataPage.storification)) {
                    if (story.highlight){
                        if (!newFormDataPage.storification) newFormDataPage.storification = {}
                        newFormDataPage.storification[storyId] = {
                            highlight: story.highlight
                        }
                        delete(formDataPage.storification[storyId].highlight)
                    }
                }
            }

            let formDataRef = deepClone(this.saveAllFormData.main)
            mergeUpdates(formDataRef, formDataPage)

            this.$set(this.saveAllFormData, 'main', deepClone(formDataRef))

            if (Object.keys(newFormDataPage).length) {
                this.$set(this.saveAllFormData.pages, pageId, newFormDataPage)
            }else{
                this.$delete(this.saveAllFormData.pages, pageId)
            }
        },

        async captureDivAndUpload(fileId) {
            try {
                const element = document.querySelector('.story-maker-post-creator .overflow');

                if (!element) {
                    throw new Error('Élément introuvable');
                }

                const canvas = await html2canvas(element, {
                    allowTaint: true,
                    useCORS: true
                });

                const imageB64 = canvas.toDataURL('image/png');
                const imageBlob = await fetch(imageB64).then(res => res.blob());
                const file = new File([imageBlob], `preview-post-${fileId}.png`);

                const formData = new FormData();
                formData.append('file', file);

                const response = await this.$http.post(
                    `${process.env.VUE_APP_API_HOST}/posts/upload/file`,
                    formData
                );

                return response.body.file_url;

            } catch (error) {
                console.error("Erreur lors de la capture ou de l'envoi :", error);
                return null;
            }
        },

        async saveDraft() {
            if (this.isSavingDraft || !this.pagesSelected.length) return
            if (this.isDemo) return this.saveDemoDraftAndPromptSignup()
            this.isSavingDraft = true
            clarityEvent(`post_save_draft:${this.mode}`)

            //set date now if post instantly
            let dateInstance = new Date((new Date).getTime() + 3600000)
            const date =  dateInstance.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-');
            const hours = dateInstance.toLocaleString('fr-FR').split(' ')[1].split(':').slice(0,2).join(':');

        
            // foreachSaveAllFormData(this.saveAllFormData, (formData, type) => {
            //     console.log("test12 foreachSaveAllFormData", type, formData.planifiedDate)
            //     if (formData.planifiedDate && (!formData.planifiedDate.date || !formData.planifiedDate.hours)) {
            //         formData.planifiedDate.date = date
            //         formData.planifiedDate.hours = hours
            //     }
            // })
            console.log('saveDraft 2', JSON.parse(JSON.stringify(this.saveAllFormData)))
            
            //this.generateFormData() //probleme si un page est selectionné (observé onglet story)
            console.log("test12 1")
            let draft, dataFormRequestByPage
            try {
                draft = this.generateDraft(
                    this.saveAllFormData,
                    this.pagesSelected
                )
                console.log("test12 Z")

                // même extraction de data (title résolu par page/réseau : mentions + troncature) que pour un post planifié
                dataFormRequestByPage = await this.generateDataFormRequest(null, this.pagesSelected, false, false)
            } catch (error) {
                this.isSavingDraft = false
                throw error
            }
            let affectedTo = {"affectedTo": null}

            if (this.idUsersAssigned.length && this.saveAllFormData.main.planifiedDate.date) {
                affectedTo =  {
                    "affectedTo": {
                        "screenshot": "",
                        "user": this.idUsersAssigned.length ? this.idUsersAssigned[0] : null,
                        "users": this.idUsersAssigned.length ? this.idUsersAssigned : [],
                        "optionValidation": this.idUsersAssigned.length ? this.requiredValidation : false // String(this.requiredValidation)
                    }
                }
            }

            // --- Nouveau flux brouillon (MongoDB/ES) ---
            // isPgDraft (flag backend) n'est pas fiable — format d'id à la place, comme Posts2.vue:97.
            const isEditMongoDraft = this.mode === 'edit' &&
                this.dataEditPost.post?.page?.[0]?.isDraft === true &&
                /^[0-9a-f]{24}$/i.test(this.dataEditPost.post?.id || this.dataEditPost.post?._id || '')

            const _buildDraftRequest = (overrideIds = {}, pgDraftId = null, logEntries = null) => {
                const allBots = this.pagesSelected.map(p => p.bots?.[0]?.id).filter(Boolean).join(',')
                const draftJson = JSON.stringify(draft)
                const logJson = logEntries && logEntries.length ? JSON.stringify(logEntries) : null
                const req = {}
                for (const page of this.pagesSelected) {
                    const botId = page.bots?.[0]?.id
                    if (!botId) continue
                    const pageDataForm = dataFormRequestByPage[page.id]
                    const hasValidPageDataForm = pageDataForm && !pageDataForm.hasOwnProperty('error')
                    const data = {
                        title: (hasValidPageDataForm ? pageDataForm.data.title : draft.form?.title) || '',
                        ...(draft.form?.enclosure && { enclosure: draft.form.enclosure }),
                        ...(draft.scheduling?.date && { scheduled_date: draft.scheduling.date }),
                        ...(hasValidPageDataForm && pageDataForm.data.storification && { storification: pageDataForm.data.storification }),
                    }
                    req[page.id] = {
                        bot: botId, service: 'dashboard', allBots,
                        isDraft: true, draft: (hasValidPageDataForm && pageDataForm.draft) || draftJson, data,
                        ...(pgDraftId && { pgDraftId }),
                        ...(logJson && { log: logJson }),
                        front_version: localStorage.getItem('front_version') || null,
                        ...(/^[0-9a-f]{24}$/i.test(overrideIds[page.id] || '') && { id: overrideIds[page.id] }),
                    }
                }
                return req
            }

            if (this.mode === 'create' || this.mode === 'duplicate') {
                EventBus.$emit('requestManagerAdd', async (onSuccess, onProgress, onError, openWindow) => {
                    try {
                        const isFirstSave = !this.draftNews
                        const logEntries = isFirstSave
                            ? [JSON.stringify(this.generateLog({ title: 'dash.posts.log.created-draft' }))]
                            : null
                        const req = _buildDraftRequest(this.draftNews || {}, null, logEntries)
                        const response = this.draftNews
                            ? await this.editAllPosts(req)
                            : await this.createAllPosts(req)
                        if (response.data.success) {
                            this.draftNews = Object.fromEntries(
                                Object.entries(response.data.news).map(([pid, n]) => [pid, n._id || n.id])
                            )
                            onSuccess(this.$t('dash.post-creator.request.draft-saved'))
                            openWindow()
                            if (isFirstSave) {
                                // Nouveau brouillon : fermer le post creator et aller sur la liste
                                this.$store.commit('selectPage/savePagesSelectedToLocalStorage')
                                this.$router.push({ name: 'posts2', params: { date: draft.scheduling.date, scrollToHour: true } })
                            }
                        } else {
                            throw new Error(this.$t('dash.post-creator.request.draft-save-failed'))
                        }
                    } catch (error) {
                        onError(error.message || error)
                        openWindow()
                    } finally {
                        this.isSavingDraft = false
                    }
                }, {
                    picture: draft.form?.enclosure,
                    title: `<span class="pink">${this.$t('dash.post-creator.request.saving-draft')}</span>`,
                    loadingText: this.$t('dash.post-creator.request.in-progress'),
                })
                return
            }

            if (isEditMongoDraft) {
                EventBus.$emit('requestManagerAdd', async (onSuccess, onProgress, onError, openWindow) => {
                    try {
                        const overrideIds = Object.fromEntries(
                            (this.dataEditPost.posts || [])
                                .map(p => [p.page, /^[0-9a-f]{24}$/i.test(p._id || '') ? p._id : null])
                                .filter(([, v]) => v)
                        )
                        // Même diff que publishEdit pour un post réel.
                        const editLog = this.generateLog({
                            title: 'dash.posts.log.edited-posts',
                            newFormData: this.saveAllFormData,
                            lastFormData: this.dataEditPost.draft?.saveAllFormData,
                            newIdUsersAssigned: this.idUsersAssigned,
                            lastIdUsersAssigned: this.dataEditPost.draft?.idUsersAssigned,
                            newRequiredValidation: this.requiredValidation,
                            lastRequiredValidation: this.dataEditPost.draft?.requiredValidation,
                        })
                        const req = _buildDraftRequest(overrideIds, null, [JSON.stringify(editLog)])
                        const response = await this.editAllPosts(req)
                        if (response.data.success) {
                            onSuccess(this.$t('dash.post-creator.request.draft-saved'))
                            openWindow()
                        } else {
                            throw new Error(this.$t('dash.post-creator.request.draft-save-failed'))
                        }
                    } catch (error) {
                        onError(error.message || error)
                        openWindow()
                    } finally {
                        this.isSavingDraft = false
                    }
                }, {
                    picture: draft.form?.enclosure,
                    title: `<span class="pink">${this.$t('dash.post-creator.request.saving-draft')}</span>`,
                    loadingText: this.$t('dash.post-creator.request.in-progress'),
                })
                return
            }
            // --- Fin nouveau flux brouillon ---

            let log = null
            if (this.mode == 'draft') {
                // Capturer l'id du brouillon PG au moment de l'appel (pas via loadMode)
                const _pgDraftId = this.draft && this.draft.id ? this.draft.id : null
                // Ancien brouillon PG → convertir en brouillon MongoDB
                EventBus.$emit('requestManagerAdd', async (onSuccess, onProgress, onError, openWindow) => {
                    try {
                        const req = _buildDraftRequest(this.draftNews || {}, _pgDraftId)
                        const response = this.draftNews
                            ? await this.editAllPosts(req)
                            : await this.createAllPosts(req)
                        if (response.data.success) {
                            this.draftNews = Object.fromEntries(
                                Object.entries(response.data.news).map(([pid, n]) => [pid, n._id || n.id])
                            )
                            onSuccess(this.$t('dash.post-creator.request.draft-saved'))
                            openWindow()
                        } else {
                            throw new Error(this.$t('dash.post-creator.request.draft-save-failed'))
                        }
                    } catch (error) {
                        onError(error.message || error)
                        openWindow()
                    } finally {
                        this.isSavingDraft = false
                    }
                }, {
                    picture: draft.form?.enclosure,
                    title: `<span class="pink">${this.$t('dash.post-creator.request.saving-draft')}</span>`,
                    loadingText: this.$t('dash.post-creator.request.in-progress'),
                })
            }else if (this.mode == 'edit'){
                // Conversion post planifié → brouillon MongoDB : editAll isDraft:true + arrêt SF backend
                EventBus.$emit('requestManagerAdd', async (onSuccess, onProgress, onError, openWindow) => {
                    try {
                        const allBots = this.dataEditPost.posts.map(p => p.bot).filter(Boolean).join(',')
                        const draftJson = JSON.stringify(draft)
                        const req = {}
                        for (const editPost of this.dataEditPost.posts) {
                            const mongoId = /^[0-9a-f]{24}$/i.test(editPost._id || '') ? editPost._id : null
                            const pageDataForm = dataFormRequestByPage[editPost.page]
                            const hasValidPageDataForm = pageDataForm && !pageDataForm.hasOwnProperty('error')
                            req[editPost.page] = {
                                bot: editPost.bot, service: 'dashboard', allBots,
                                isDraft: true, draft: (hasValidPageDataForm && pageDataForm.draft) || draftJson,
                                ...(mongoId && { id: mongoId }),
                                data: {
                                    title: (hasValidPageDataForm ? pageDataForm.data.title : draft.form?.title) || '',
                                    ...(draft.form?.enclosure && { enclosure: draft.form.enclosure }),
                                    ...(draft.scheduling?.date && { scheduled_date: draft.scheduling.date }),
                                    ...(hasValidPageDataForm && pageDataForm.data.storification && { storification: pageDataForm.data.storification }),
                                },
                                front_version: localStorage.getItem('front_version') || null,
                            }
                        }
                        const response = await this.editAllPosts(req)
                        if (response.data.success) {
                            onSuccess(this.$t('dash.post-creator.request.draft-converted'))
                            openWindow()
                            this.$store.commit('selectPage/savePagesSelectedToLocalStorage')
                            this.$router.push({ name: 'posts2', params: { date: draft.scheduling.date, scrollToHour: true } })
                        } else {
                            throw new Error(this.$t('dash.post-creator.request.draft-convert-failed'))
                        }
                    } catch (error) {
                        onError(error.message)
                        openWindow()
                    } finally {
                        this.isSavingDraft = false
                    }
                }, {
                    picture: draft.form?.enclosure,
                    title: `<span class="pink">${this.$t('dash.post-creator.request.converting-draft')}</span>`,
                    loadingText: this.$t('dash.post-creator.request.converting'),
                })
            }else{
                log = this.generateLog({
                   title: 'dash.posts.log.created-draft',
                })
                EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError, openWindow)=> {
                    try {
                        let enclosure = draft.tab == 'story' ?  await this.captureDivAndUpload(this.draft.id) : null

                        this.$store.commit('selectPage/savePagesSelectedToLocalStorage');
                        this.$router.push({
                            name: 'posts2',
                            params: { 
                                date: draft.scheduling.date || new Date().toISOString(),
                                scrollToHour: true
                            }
                        })
                       
                        const dataNewDraft = {
                            ...draftTemplate,
                            ...draft, 
                            ...affectedTo,
                            log : [JSON.stringify(log)]
                        }

                        if (enclosure) {
                            dataNewDraft.form.enclosure = enclosure
                        }


                        const response = await this.newDraft(dataNewDraft);
                        
                        //logs for backend debug
                        this.addLog(this.currentUser, 'create-draft', {
                            payload: dataNewDraft,
                            response: response
                        })

                        if (response.data.success) {
                            onSuccess(this.$t('dash.post-creator.request.draft-created'));
                            this.draft = {
                                data : draft,
                                id : response.data.draft.id
                            }
                            this.$store.commit('postCreator/setDataForDraft', this.draft);
                            openWindow()
                            // this.$router.push('/dash/postCreator/draft');
                        }else{
                            throw new Error(this.$t('dash.post-creator.request.draft-create-failed'));
                        }
                    } catch (error) {
                        console.error(error)
                        onError(error.message);
                        openWindow()
                    } finally {
                        this.isSavingDraft = false
                    }
                    }, {
                    picture: draft.form.enclosure,
                    title:`<span class="pink">${this.$t('dash.post-creator.request.creating-draft')}</span>`,
                    loadingText: this.$t('dash.post-creator.request.creating'),
                })

              
            }
        },

        // Entry point kept for the template's @click - only decides whether a publish needs to wait
        // on a still-running mediaEditor export (see StandardTab.vue/StoryTab.vue's
        // getPendingMediaExportJobIds) before dispatching to the actual publish logic
        // (publishPost.js's runPublishBranch, called from either sendPostAllPostImmediate or
        // sendPostAllPostDeferred below - never duplicated between the two).
        async sendPostAllPost() {
            if (this.isFileUploading || this.hasFailedUpload) return
            if (this.isDemo) return this.saveDemoDraftAndPromptSignup()

            const activeTabRef = this.$refs.standardTab || this.$refs.storyTab
            const pendingSessions = (activeTabRef && activeTabRef.getPendingMediaExportSessionsInfo)
                ? activeTabRef.getPendingMediaExportSessionsInfo()
                : []

            if (pendingSessions.length) {
                return this.sendPostAllPostDeferred(activeTabRef, pendingSessions)
            }

            return this.sendPostAllPostImmediate()
        },

        // Public demo (see DemoPostCreator.vue): nothing is ever really published - the composed
        // post is stashed in localStorage, in the exact shape loadMode()'s 'draft' case expects
        // (postCreator/getDataDraft), so it can be resumed as a normal draft once the visitor signs
        // up and connects a real page (remapping fake page ids -> real ones happens at that point,
        // see the /dash route guard in router/index.js).
        saveDemoDraftAndPromptSignup() {
            // Flushes the "main" scope's live this.formData into this.saveAllFormData.main - it's
            // normally kept in sync as the visitor types (Form.vue's Editor emits saveFormData on
            // every text change), but this removes any dependency on that having actually fired by
            // the time this runs (e.g. a per-page/network customization left as the active scope).
            this.saveFormData()
            const pendingDemoDraft = {
                draft: {
                    id: 'demo-draft',
                    data: {
                        tab: this.tab,
                        files: this.files,
                        saveAllFormData: this.saveAllFormData,
                        idUsersAssigned: [],
                        requiredValidation: false,
                        log: [],
                        pages: this.pagesSelected.map(page => page.id)
                    }
                },
                // Parallel array (same order/length as draft.data.pages) of the fake page's
                // network - the only thing the router guard needs to remap fake page ids -> the
                // visitor's real, freshly-connected page of that network once they sign up (see
                // attemptResumeDemoDraft in router/index.js). Real page ids are never involved on
                // this side - they don't exist yet.
                demoNetworks: this.pagesSelected.map(page => page.network)
            }

            try {
                localStorage.setItem('demo/pendingDraft', JSON.stringify(pendingDemoDraft))
            } catch (error) {
                console.error('[PostCreator] failed to save demo draft', error)
            }

            // The acknowledgement popup is shown once landing on the signup form itself (see
            // views/Auth.vue's handling of ?ref=demo), not here - one clear stop right before the
            // action it's about, instead of a popup-then-navigate-again detour.
            this.$router.push('/?ref=demo')
        },

        // Bound instance methods the publishPost.js branches call - confirmed to only ever depend on
        // this.$http/this.$store/plain params (see mixins/Posts.vue, mixins/Drafts.vue,
        // mixins/Common.vue, postCreator/mixins/main.js's generateLog), so binding them here and
        // handing them to a function that may run long after this component is destroyed (deferred
        // path, after the immediate navigation below) is safe - same "component destroyed mid-
        // .then()" pattern this code already relied on before this feature (see the un-awaited
        // createAllPosts(...).then() chains that already survived the unconditional router.push).
        // i18n has no standalone (non-component) access pattern anywhere else in this codebase - `t`
        // is `this.$t` bound here instead (see publishPost.js's header comment).
        _publishDeps() {
            return {
                createAllPosts: this.createAllPosts.bind(this),
                editAllPosts: this.editAllPosts.bind(this),
                generateLog: this.generateLog.bind(this),
                addLog: this.addLog.bind(this),
                deleteDraft: this.deleteDraft.bind(this),
                events: this.events.bind(this),
                t: this.$t.bind(this),
            }
        },

        // Every field publishPost.js's branches read instead of `this.x` - see its header comment
        // for which branch reads which field. `dataFormRequest`/`files` are passed BY REFERENCE (not
        // cloned) on purpose: the branches mutate dataFormRequest in place (deleting failed-page
        // entries), and the final navigation below still reads `this.dataFormRequest` afterwards -
        // exactly like today, since publishPost.js's mutations land on the same object.
        _publishSnapshot() {
            return {
                mode: this.mode,
                dataFormRequest: this.dataFormRequest,
                dataEditPost: this.dataEditPost,
                draft: this.draft,
                draftNews: this.draftNews,
                saveAllFormData: this.saveAllFormData,
                idUsersAssigned: this.idUsersAssigned,
                requiredValidation: this.requiredValidation,
                pagesSelected: this.pagesSelected,
                allPages: this.allPages,
                currentUser: this.currentUser,
                logs: this.logs,
                files: this.files,
            }
        },

        // The "nothing pending" fast path - 100% behaviorally identical to the pre-existing
        // switch(this.mode) body (now living in publishPost.js's runPublishBranch instead, so this
        // exact same logic is also reusable from sendPostAllPostDeferred below). Still fires the
        // createAllPosts/editAllPosts chain WITHOUT awaiting it (same as before), and still navigates
        // away immediately afterwards regardless of that chain's outcome (same as before).
        async sendPostAllPostImmediate() {
            runPublishBranch(this.mode, this._publishSnapshot(), this._publishDeps())

            this.$store.commit('selectPage/savePagesSelectedToLocalStorage');
            this.$router.push({
                name: 'posts2',
                params: {
                    date: Object.values(this.dataFormRequest)[0].data.scheduled_date || new Date().toISOString(),
                    scrollToHour: true
                }
            })
        },

        // Cas A of the deferred-publish safety net (see sendPostAllPostDeferred) - mode is
        // 'create'/'duplicate', so there's no post/draft yet with a stable id to fall back on if the
        // pending export ultimately fails. Creates a REAL MongoDB draft right away (same
        // construction saveDraft()'s own 'create'/'duplicate' branch uses via its local
        // _buildDraftRequest - duplicated here rather than shared, see this method's own risk/report
        // notes) using the CURRENT pre-edit thumbnail (draft.form.enclosure) as a safe placeholder -
        // never the still-exporting file. It shows up in the planner immediately, and its id is what
        // "Ouvrir le post" (see sendPostAllPostDeferred's onAction) reopens if the export fails.
        //
        // typePost is set explicitly here (not left for a later regeneration to fix) because the
        // planner's own icon (posts/mixins/main.js's buildEvent) reads post.page[0].typePost first,
        // falling back to guessing from the enclosure's file extension only when it's absent - a
        // draft created without it (or with the pre-edit image's own type) risked that stale
        // typePost-less/image state surviving the later draft-to-post conversion depending on how
        // the backend merges it, showing a wrong image-shaped icon for what is actually a video.
        async createSafetyDraftForPendingPublish(typePost) {
            const draft = this.generateDraft(this.saveAllFormData, this.pagesSelected)
            const dataFormRequestByPage = await this.generateDataFormRequest(null, this.pagesSelected, false, false)

            const allBots = this.pagesSelected.map(p => p.bots?.[0]?.id).filter(Boolean).join(',')
            const draftJson = JSON.stringify(draft)
            const req = {}
            for (const page of this.pagesSelected) {
                const botId = page.bots?.[0]?.id
                if (!botId) continue
                const pageDataForm = dataFormRequestByPage[page.id]
                const hasValidPageDataForm = pageDataForm && !pageDataForm.hasOwnProperty('error')
                const data = {
                    title: (hasValidPageDataForm ? pageDataForm.data.title : draft.form?.title) || '',
                    typePost,
                    postImage: typePost === 'image',
                    ...(draft.form?.enclosure && { enclosure: draft.form.enclosure }),
                    ...(draft.scheduling?.date && { scheduled_date: draft.scheduling.date }),
                }
                req[page.id] = {
                    bot: botId, service: 'dashboard', allBots,
                    isDraft: true, draft: (hasValidPageDataForm && pageDataForm.draft) || draftJson, data,
                    front_version: localStorage.getItem('front_version') || null,
                }
            }

            const response = await this.createAllPosts(req)
            if (!response.data.success) throw new Error(this.$t('dash.post-creator.request.draft-save-failed'))

            this.draftNews = Object.fromEntries(
                Object.entries(response.data.news).map(([pid, n]) => [pid, n._id || n.id])
            )
            const draftId = Object.values(this.draftNews)[0] || null

            // "post"/"posts" reopening shape (see drawer/index.vue:465-472,496-501's
            // setDataForEditPost pattern) - best-effort stubs, NOT a fully hydrated post as the
            // planner would normally supply (no _bots, no real page[0] metadata beyond what
            // loadMode() strictly reads). Sufficient to reopen this draft in edit mode and retry
            // (loadMode() only needs draft.saveAllFormData/.files truthy and post.page[0].log to
            // exist) - see this method's report notes for the tradeoff.
            const posts = this.pagesSelected
                .filter(page => this.draftNews[page.id])
                .map(page => ({
                    _id: this.draftNews[page.id],
                    id: this.draftNews[page.id],
                    bot: page.bots?.[0]?.id,
                    page: page.id,
                    postId: null,
                    status: 0,
                }))

            const post = {
                id: draftId,
                page: [{
                    log: [],
                    isDraft: true,
                    isPgDraft: false,
                    affectedTo: null,
                    wait_validation: null,
                }]
            }

            return { draftId, draft, posts, post }
        },

        // Non-empty pendingSessions - at least one mediaEditor export this post depends on is still
        // running. Claims those jobs (so StandardTab.vue's endEditMedia/onExportFailed become
        // no-ops for them if the user is still on this same page), creates the draft safety-net if
        // needed (Cas A), registers the wait with mediaExportJobs.js, and hands the actual publish
        // off to a single RequestManager row that awaits the export(s) before running it - all
        // without blocking this method's own immediate return/navigation below (mirrors the
        // pre-existing un-awaited createAllPosts(...).then() pattern, just deferred further out).
        async sendPostAllPostDeferred(activeTabRef, pendingSessions) {
            const jobIds = pendingSessions.map(s => s.jobId)

            const deps = this._publishDeps()
            const uploadFile = this.uploadFile.bind(this)
            const generateDataFormRequest = this.generateDataFormRequest.bind(this)
            const applyBackgroundMediaResult = this.applyBackgroundMediaResult.bind(this)

            let draftId = null
            let reopenInfo = null
            let effectiveMode = this.mode

            // Drives the safety draft's own typePost below (see createSafetyDraftForPendingPublish) -
            // 'photo' only if EVERY pending job is a photo-mode export, 'video' otherwise (the safer
            // default when mixed/unknown, since a video wrongly typed as photo is a much more visible
            // planner glitch than the reverse - see the icon bug this was written to fix).
            const jobs = this.$store.state.mediaExportJobs.jobs
            const typePost = jobIds.every(id => jobs[id] && jobs[id].kind === 'photo') ? 'image' : 'video'

            try {
                if (this.mode === 'create' || this.mode === 'duplicate') {
                    const safety = await this.createSafetyDraftForPendingPublish(typePost)
                    draftId = safety.draftId
                    reopenInfo = { kind: 'edit', draft: safety.draft, posts: safety.posts, post: safety.post }
                    // The safety draft already exists for real (this.draftNews now points at it,
                    // see createSafetyDraftForPendingPublish) - the eventual publish below must
                    // CONVERT it into the final post (publishPost.js's publishDraft, draftNews
                    // sub-path: editAllPosts targeting these very ids), not create a brand new post
                    // from scratch, which would leave this safety draft orphaned in the planner.
                    effectiveMode = 'draft'
                } else if (this.mode === 'edit' || this.mode === 'update') {
                    // Cas B - the post already exists with a stable id, nothing to create; it stays
                    // untouched (its previous media) until the export resolves.
                    reopenInfo = { kind: 'edit', draft: this.dataEditPost.draft, posts: this.dataEditPost.posts, post: this.dataEditPost.post }
                } else if (this.mode === 'draft') {
                    reopenInfo = { kind: 'draft', data: this.draft.data, id: this.draft.id }
                }
                // Only claimed once we're actually committed to the deferred path (safety draft, if
                // any, already created) - claiming any earlier and then falling back to the
                // immediate path below (catch block) would leave these jobs' eventual results
                // unreachable: claimed jobs are permanently ignored by StandardTab.vue's own
                // endEditMedia/onExportFailed, but no pendingPublish would exist to consume them
                // either.
                activeTabRef.claimMediaExportJobIds(jobIds)
            } catch (error) {
                console.error('[PostCreator] sendPostAllPost: safety draft creation failed, falling back to the immediate path', error)
                Sentry.captureException(error)
                // Sans brouillon de secours fiable, mieux vaut republier avec le média pré-édition
                // (comportement actuel) que perdre silencieusement la publication.
                return this.sendPostAllPostImmediate()
            }

            const snapshot = this._publishSnapshot()
            snapshot.mode = effectiveMode
            if (effectiveMode === 'draft' && draftId) {
                // Only used by publishDraft for its (here, always-true) draftNews branch's logging -
                // see this method's report notes: not a real PG draft, `data` stays undefined and
                // generateLog tolerates that (newFormData/lastFormData both required to compute a
                // diff, see postCreator/mixins/main.js's generateLog).
                snapshot.draft = { id: draftId, data: undefined }
            }

            // Used by mediaExportJobs.js's isPostLocked getter (planner/drawer lock, see
            // posts/components/drawer/index.vue) - reopenInfo.posts already carries the right shape
            // for both Cas A (the safety draft's freshly-created posts) and Cas B (the real post's
            // own dataEditPost.posts) since it's built from the exact same data above. Mode 'draft'
            // (reopenInfo.kind === 'draft', a PG draft being re-edited) has no equivalent posts
            // array to lock against - left unlocked rather than guessing at one.
            const { publishId, resultPromise } = await this.$store.dispatch('mediaExportJobs/registerPendingPublish', {
                jobIds,
                snapshot,
                draftId,
                posts: reopenInfo && reopenInfo.kind === 'edit' ? reopenInfo.posts : []
            })

            const firstFormData = Object.values(this.dataFormRequest)[0]
            const waitingForMediaKey = jobIds.length > 1 ? 'dash.post-creator.request.waiting-for-medias' : 'dash.post-creator.request.waiting-for-media'

            // Real percentage, not just an indeterminate spinner - averages every pending job's own
            // progress (mediaExportJobs.js, a 0-1 fraction) and reports it as "NN% ..." so
            // RequestManager.vue's changeProgressRequest (which parses a leading "NN%" out of the
            // text it's given) actually drives the progress bar's width, not just its label.
            const reportExportProgress = (onProgress) => {
                const jobs = this.$store.state.mediaExportJobs.jobs
                const progresses = jobIds.map(id => (jobs[id] ? jobs[id].progress : 0) || 0)
                const avgPct = Math.round((progresses.reduce((a, b) => a + b, 0) / progresses.length) * 100)
                onProgress(`${avgPct}% ${this.$t(waitingForMediaKey)}`)
            }

            // One row per page from the very start - no separate "media" row (a page's own row
            // should behave exactly like a plain post's, just with an extra initial phase). Phase 1:
            // reports the SHARED export progress while runSharedWork() below (memoized - its actual
            // body runs only once no matter how many rows await it) uploads the result and
            // regenerates dataFormRequest. Phase 2: hands off to the SAME real per-page publish
            // tracking runPublishBranch already builds (EventSource progress/success/failure) via
            // deps.publishRequestGroup, routed into pageRowHandles instead of spawning new rows.
            const pageRowHandles = {}
            let sharedWorkPromise = null
            const runSharedWork = () => {
                if (sharedWorkPromise) return sharedWorkPromise
                sharedWorkPromise = (async () => {
                    const resolvedFiles = await resultPromise // rejects with the first failed job's error

                    for (let i = 0; i < pendingSessions.length; i++) {
                        const { scopeKey, fileIdOrigin, timelineState, extraFiles, storyId } = pendingSessions[i]
                        const file = resolvedFiles[i]
                        const newFileId = Math.random().toString(36).substr(2, 9)

                        // uploadFile() never rejects (it catches internally and just marks the file
                        // failedUpload) - check the resulting file entry rather than await a rejection.
                        await uploadFile(null, file, true, newFileId, null)
                        const uploaded = this.files[newFileId]
                        if (!uploaded || !uploaded.isUpload || uploaded.failedUpload) {
                            throw new Error('Échec de l’upload du média exporté')
                        }

                        // mediaEditorData carries the "resume" data (see StandardTab.vue's
                        // endEditMedia/getPendingMediaExportSessionsInfo) - without it, re-opening
                        // this published media in the editor would show only the flattened export
                        // with no way back to the original clips/overlays/cuts.
                        applyBackgroundMediaResult({
                            scopeKey,
                            fileIdOrigin,
                            storyId,
                            buildNewEntry: () => ({ id: newFileId, mediaEditorData: { fileIdOrigin, timelineState, extraFiles } })
                        })
                    }

                    // Re-derive dataFormRequest now that saveAllFormData/files reflect the exported
                    // media (applyBackgroundMediaResult above just patched them in place) - same call
                    // saveDraft() already uses; reads the just-mutated live state.
                    snapshot.dataFormRequest = await generateDataFormRequest(null, snapshot.pagesSelected, false, false)

                    deps.publishRequestGroup = (requestGroup, cbFinish) => {
                        requestGroup.forEach((entry) => {
                            const handle = pageRowHandles[entry.pageId]
                            if (!handle) return
                            entry.start(
                                (msg) => { handle.settled = true; handle.onSuccess(msg) },
                                handle.onProgress,
                                (msg) => { handle.settled = true; handle.onError(msg) }
                            )
                        })
                        if (cbFinish) cbFinish([])
                    }

                    await runPublishBranch(snapshot.mode, snapshot, deps)
                })().finally(() => {
                    this.$store.dispatch('mediaExportJobs/clearPendingPublish', { publishId })
                })
                return sharedWorkPromise
            }

            // Safety net: publishPost.js's branches already swallow a createAllPosts/editAllPosts
            // network failure into a console.log (pre-existing behavior, unchanged here) - when that
            // happens, runSharedWork() resolves normally without deps.publishRequestGroup ever having
            // routed anything, which would otherwise leave these rows stuck "loading" forever. 90s
            // comfortably exceeds how long a legitimate EventSource-driven publish takes.
            setTimeout(() => {
                Object.values(pageRowHandles).forEach((handle) => {
                    if (handle.settled) return
                    handle.settled = true
                    handle.onError(this.$t('dash.post-creator.request.post-publish-failed'))
                })
            }, 90000)

            Object.keys(snapshot.dataFormRequest).forEach((pageId) => {
                if (snapshot.dataFormRequest[pageId].hasOwnProperty('error')) return
                const page = snapshot.pagesSelected.find(p => p.id == pageId) || snapshot.allPages[pageId]

                EventBus.$emit('requestManagerAdd', async (onSuccess, onProgress, onError, openWindow) => {
                    pageRowHandles[pageId] = { onSuccess, onProgress, onError, settled: false }
                    const unwatch = this.$store.watch(
                        (state) => jobIds.map(id => state.mediaExportJobs.jobs[id] && state.mediaExportJobs.jobs[id].progress),
                        () => reportExportProgress(onProgress)
                    )
                    reportExportProgress(onProgress)
                    try {
                        await runSharedWork()
                        // Success/failure for THIS page now comes from its own real per-page
                        // tracking (see deps.publishRequestGroup above), invoked asynchronously
                        // later via pageRowHandles - nothing more to do here once the shared work
                        // itself has kicked it off.
                    } catch (error) {
                        console.error('[PostCreator] deferred publish failed', error)
                        pageRowHandles[pageId].settled = true
                        onError(error && error.message ? error.message : this.$t('dash.post-creator.request.post-publish-failed'))
                        openWindow()
                    } finally {
                        unwatch()
                    }
                }, {
                    picture: page?.avatar,
                    title: page ? `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>` : '',
                    loadingText: this.$t(waitingForMediaKey),
                    // Opens the panel right away - otherwise nothing visibly happens until the
                    // export (which can take minutes) finishes, since nothing else triggers `open()`
                    // before a row actually settles (see RequestManager.vue's scheduleAutoOpen, only
                    // called from successRequest/errorRequest). Harmless on every row - open() is a
                    // no-op once already open.
                    autoOpen: true,
                    // Only useful to recover from a failure (reopen the safety draft/post to retry) -
                    // not shown on success (see RequestManager.vue's actionVisibility).
                    actionVisibility: 'error',
                    onAction: () => {
                        if (!reopenInfo) return
                        if (reopenInfo.kind === 'draft') {
                            this.$store.commit('postCreator/setDataForDraft', { data: reopenInfo.data, id: reopenInfo.id })
                            this.$router.push('/dash/postCreator/draft')
                        } else {
                            this.$store.commit('postCreator/setDataForEditPost', { draft: reopenInfo.draft, posts: reopenInfo.posts, post: reopenInfo.post })
                            this.$router.push('/dash/postCreator/edit')
                        }
                    }
                })
            })

            // Same unconditional immediate navigation as sendPostAllPostImmediate/today - the
            // post-creator closes right away regardless of the pending export/publish outcome.
            this.$store.commit('selectPage/savePagesSelectedToLocalStorage');
            this.$router.push({
                name: 'posts2',
                params: {
                    date: firstFormData?.data.scheduled_date || new Date().toISOString(),
                    scrollToHour: true
                }
            })
        },

        async changePreviewDisplay(state, pageSelected = null) {
            console.log("changePreviewDisplay", {state, pageSelected})

            if (state) {
                if (pageSelected) {
                    this.$set(this.previewMode, 'pageSelected', pageSelected)
                }else if (!this.previewMode.pageSelected) {
                    for (let i = 0; i < listNetworkSort.length; i++) {
                        const page = this.pagesSelected.find(p => p.network == listNetworkSort[i])
                        if (page) {
                            this.$set(this.previewMode, 'pageSelected', page)
                            break
                        }
                    }
                }
                console.log('this.previewMode.pageSelected', this.previewMode.pageSelected)
                if (!this.previewMode.active) {
                    this.handlePreGenerateDataFormRequest()
                    this.$set(this.previewMode, 'active', true)
                }
            }else{
                this.$set(this.previewMode, 'active', false)
                // this.$refs.postCreator.classList.remove('annimate-switch-preview-mode');

                // if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                // this.$nextTick(() => {
                //     this.timeOutAnnimateForm = setTimeout(() => {
                //         if (this.formShow == "preview-left") {
                //             this.formShow = "formUnique"
                //         }else{
                //             this.formShow = "formMultiple"
                //         }
                //     }, 1000);
                // })
            }
        },

        async handlePreGenerateDataFormRequest(cb) {

            let pagesSelected = this.tab == 'story' ? this.pagesSelected.filter(page => page.network == 'instagram' || (page.network == 'facebook' && page.story_config && page.story_config.created)) : this.pagesSelected
            console.log("handlePreGenerateDataFormRequest", this.mode, pagesSelected)
            switch (this.mode) {
                case 'update':
                    pagesSelected = pagesSelected.filter(page => editableNetworks.includes(page.network))
                    break
                case 'draft':
                   
                    break;
                
                case 'edit':
                    if (this.dataEditPost.post.page[0].affectedTo) {

                        if (
                            (this.dataEditPost.post.page[0].affectedTo.user && this.dataEditPost.post.page[0].affectedTo.user.id == this.currentUser.id) ||
                            (this.dataEditPost.post.page[0].affectedTo.users && this.dataEditPost.post.page[0].affectedTo.users.some(user => user.id == this.currentUser.id))
                        ) {
                            this.generateDataFormRequest(cb , pagesSelected, false, false)
                            return
                        }

                        if (  
                            !this.dataEditPost.post.page[0].wait_validation || 
                            this.dataEditPost.post.page[0].wait_validation == 'null'
                        ) {
                            EventBus.$emit("showModal",
                                this.$t('dash.post-creator.modal.update-notification-title'),
                                this.$t('dash.post-creator.modal.update-notification-body'),
                                this.$t('dash.post-creator.modal.send'),
                                this.$t('dash.post-creator.modal.do-not-send'),
                                ()=>{
                                    this.generateDataFormRequest(cb , pagesSelected, null, true)
                                },
                                ()=>{
                                    this.generateDataFormRequest(cb, pagesSelected, null, false)
                                },
                            );
                            return
                        }
                    
                        if (
                            this.requiredValidation &&
                            this.dataEditPost.post.page[0].affectedTo.optionValidation && 
                            this.dataEditPost.post.page[0].wait_validation && 
                            this.dataEditPost.post.page[0].wait_validation !== 'null'
                        ) {
                            EventBus.$emit("showModal",
                                this.$t("dash.post.resetWaitValidation.title"),
                                this.$t("dash.post.resetWaitValidation.body"),
                                this.$t('dash.post-creator.modal.send'),
                                this.$t('dash.post-creator.modal.do-not-send'),
                                ()=>{
                                    this.generateDataFormRequest(cb, pagesSelected, true)
                                },
                                ()=>{
                                    this.generateDataFormRequest(cb, pagesSelected, false)
                                },
                            );
                            return
                        }
                    }
                    break;        
            }
            
            this.generateDataFormRequest(cb , pagesSelected, false, false)           
        },

        async deletePostFromClickSelectPage(params) {
            //Suprime le post liée a une page
            const post = this.dataEditPost.posts.find(post => post.page == params.pageId);
            const page = this.pagesSelected.find((page) => page.id == params.pageId)

            this.$set(this.dataEditPost, 'posts', this.dataEditPost.posts.filter(post => post.page !== params.pageId))
            this.$store.commit('selectPage/updatePagesSelected', {saveToLocalStorage: false, pagesId: this.pagesSelected.filter(page => page.id !== params.pageId).map(p => p.id)})
            
            EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError)=> {

                try {
                    const response = await this.deletePost({
                        _id: post._id,
                        _bots:[{
                            id: post.bot,
                            page: {
                                network: page.network,
                            }
                        }],
                        page: [{
                            post_number: post.postId,
                            status: post.status
                        }]
                    });

                    this.newLog(
                        post._id, 
                        JSON.stringify(this.generateLog({
                            title: 'dash.posts.log.deleted-post-editor',
                        }))
                        , false
                    )

                    if (response.data.success) {
                        onSuccess(this.$t('dash.post-creator.request.post-deleted'));
                    }else{
                        throw new Error(this.$t('dash.post-creator.request.post-delete-failed'));
                    }
                } catch (error) {
                    this.$set(this.dataEditPost, 'posts', [...this.dataEditPost.posts, post])
                    this.$store.commit('selectPage/updatePagesSelected', {
                        saveToLocalStorage: false, 
                        pagesId:[...this.pagesSelected.map(p => p.id), post.page]})
                        
                    onError(error.message);
                }  
            }, {
                picture: page.avatar,
                title:`<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${this.$t('dash.post-creator.request.post-scheduled-label')}`,
                loadingText: this.$t('dash.post-creator.request.deleting'),
            })
        },

        getAssignUserLocalStorage() {
            const ids = JSON.parse(localStorage.getItem('postCreator/lastIdUsersAssigned') || '[]')

            return ids.filter(id => (
                id !== this.currentUser.id && 
                this.users[id] && 
                (
                    (this.users[id].admin && (!this.users[id].pages_access || this.users[id].pages_access.length == 0)) || 
                    (this.users[id].pages_access && this.users[id].pages_access.length && this.pagesSelected.every(page => this.users[id].pages_access.includes(page.id)))
                )

            ))
        },

        assignUsers() {
            //Retirer les utilisateurs qui n'ont pas accès à l'ensemble des pages sélectionnées
            const usersForSelector = Object.fromEntries(
                Object.entries(this.$store.getters['users/getUsers']).filter(([userId, user]) => 
                    user.id !== this.currentUser.id && 
                    (
                        (user.admin && (!user.pages_access || user.pages_access.length == 0)) || 
                        (user.pages_access && user.pages_access.length && this.pagesSelected.every(page => user.pages_access.includes(page.id) && !(user.role?.includes('Writter'))))
                    )
                )
            );
            console.log("usersForSelector", usersForSelector)
            EventBus.$emit('selectUsers',(idUsersSelected, formCustom)=>{
                this.idUsersAssigned = idUsersSelected                
                if (formCustom && formCustom[0] && formCustom[0].name == "optionValidation") {
                    this.requiredValidation = formCustom[0].value
                }
                localStorage.setItem('postCreator/lastIdUsersAssigned', JSON.stringify(idUsersSelected))
            },{
                users: usersForSelector,
                defaultSelection: this.idUsersAssigned,
                subTitle: this.$t('dash.post-creator.assign.subtitle'),
                validButtonText: (idUsersAssigned) => {
                    if (idUsersAssigned.length == 0) {
                        return this.$t('dash.post-creator.assign.validate')
                    }
                    if (this.idUsersAssigned.length == 0 && idUsersAssigned.length > 0) {
                        return this.$t('dash.select-users.assign')
                    }
                    if (
                        idUsersAssigned.length === this.idUsersAssigned.length &&
                        [...idUsersAssigned].sort().join() === [...this.idUsersAssigned].sort().join()
                    ) {
                        return this.$t('dash.select-users.assign')
                    }

                    return this.$t('dash.post-creator.assign.update')

                },

                formCustom: [
                    {
                        type: 'checkbox',
                        name: 'optionValidation',
                        label: this.$t('dash.post-creator.assign.required-validation'),
                        value: this.requiredValidation,
                        show: (idUsersAssigned) => idUsersAssigned.length > 0,
                    },
                ],
            })
        },

        unassignCurrentUser() {
            this.idUsersAssigned = this.idUsersAssigned.filter(id => id != this.currentUser.id)
        },

        // Only 'create'/'duplicate' have a restore path today (see retoreDraftInLocalStorage)
        autosaveDraftToRestore() {
            if (!['duplicate', 'create'].includes(this.mode)) return
            localStorage.setItem('postCreator/draftToRestore',
                JSON.stringify(this.generateDraft(this.saveAllFormData, this.pagesSelected))
            )
        },

        retoreDraftInLocalStorage() {
            console.log('retoreDraftInLocalStorage')
            if (this.canRestoreDraft) {
                const draftToRestore = JSON.parse(localStorage.getItem('postCreator/draftToRestore'))
                console.log('retoreDraftInLocalStorage', draftToRestore)
                if (draftToRestore) {
                    this.$store.commit('postCreator/setDataForDuplicatePost', {
                        draft: draftToRestore,
                        pages: draftToRestore.pages
                    });
                    this.canRestoreDraft = false
                    this.mode = 'duplicate'
                    this.loadMode()
                }
            
            }
        },


        async compressImageStrict(url) {
            return axios.get(`${process.env.VUE_APP_VIDEO_API_HOST}/v2/image/normalize?network=engine-compress&url=${encodeURIComponent(url)}`, {
                timeout: LIGHT_REQUEST_TIMEOUT_MS
            })
        },

        async normalizeImageForNetworkStrict(url, network) {
            return axios.get(`${process.env.VUE_APP_VIDEO_API_HOST}/v2/image/normalize?network=${network}&url=${encodeURIComponent(url)}`, {
                timeout: LIGHT_REQUEST_TIMEOUT_MS
            })
        },

        async compressMedia(idFile) {
          if (!this.files[idFile]) return;

          const file = this.files[idFile];
          try {
            switch (file.info.type2) {
              case 'image':
                const resCompressImage = await withRetry(() => this.compressImageStrict(file.url), {
                    retries: 3,
                    onRetry: (attempt, error) => {
                        Sentry.addBreadcrumb({ category: 'upload', level: 'warning', message: `compressImage retry #${attempt}`, data: { fileId: idFile, error: error?.message } })
                    }
                });

                if (resCompressImage?.data?.url) {
                    this.$set(this.files[idFile], 'url', resCompressImage.data.url);
                    this.$set(this.files[idFile].info, 'enclosure', resCompressImage.data.url);
                } else {
                    this.addLog(this.currentUser, `compress-image-error`, {
                        resCompressImage: resCompressImage
                    })
                }

                if (resCompressImage.data.infos) {
                    this.$set(this.files[idFile].info, 'width', resCompressImage.data.infos.width);
                    this.$set(this.files[idFile].info, 'height', resCompressImage.data.infos.height);
                    this.$set(this.files[idFile].info, 'size', resCompressImage.data.infos.size);
                }

              break;

              case 'video':

                if (['video/x-matroska'].includes(file.type)) {

                  const sourceNormalizeVideo = new SSE(
                      `${process.env.VUE_APP_VIDEO_API_HOST}/v2/video/normalize?type=force-compress'&url=${encodeURIComponent(response.file_url)}`,
                  );
                            
                  const resNormalizeVideo = await new Promise((resolveNorm, rejectNorm) => {
                      sourceNormalizeVideo.onmessage = (eventNorm) => {
                          let responseNorm = JSON.parse(eventNorm.data);

                          if (responseNorm.success) resolveNorm(responseNorm)
                          else if (responseNorm.error || responseNorm.end) {
                              rejectNorm(responseNorm.error)
                          }else if (responseNorm.percent) {
                              this.$set(this.files[idFile], 'percentUpload', responseNorm.percent);
                          }
                      };
                      sourceNormalizeVideo.onopen = () => this.$set(this.files[idFile], 'percentUpload', 1);
                      sourceNormalizeVideo.stream((progress) => progress.lengthComputable && this.$set(this.files[idFile], 'percentUpload', (progress.loaded / progress.total) * 100));
                      sourceNormalizeVideo.onerror = (error) => {
                          console.error("error normalize video", error)
                          rejectNorm(error)
                      };
                  });

                  if (resNormalizeVideo.url) {
                      this.$set(this.files[idFile], 'url', resNormalizeVideo.url);

                      //recalcule info file
                      try {
                          const responseFetch = await fetch(resNormalizeVideo.url);
                          const blobNormalizeVideo = await responseFetch.blob();
                          const fileNormalizeVideo = new File([blobNormalizeVideo], info.name, {
                              type: blobNormalizeVideo.type,
                              lastModified: new Date().getTime()
                          });
                    
                          this.$set(this.files[idFile], 'info', await getInfoFile(fileNormalizeVideo, resNormalizeVideo.url));
                          
                      } catch (error) {
                          console.error("error get info lors de compressMedia", error)
                      }
                  }

                }

                await this.fetchVideoThumbnail(idFile)

              break;
            }
          } catch (error) {
              console.error("error normalizing image", error);
          }

        },

        // Sets info.enclosure (the post's preview thumbnail) from a server-side generated frame -
        // server-side so it works for S3 urls too, where canvas frame capture is CORS-blocked.
        async fetchVideoThumbnail(idFile) {
            if (!this.files[idFile]) return;

            const url = this.files[idFile].url
            const fetchThumbnail = async () => {
                const controller = new AbortController()
                const timer = setTimeout(() => controller.abort(), LIGHT_REQUEST_TIMEOUT_MS)
                try {
                    const res = await fetch(`https://media.mashup-web.com/video/thumbnail?url=${encodeURIComponent(url)}`, { signal: controller.signal });
                    const data = await res.json();
                    return data.url || null;
                } finally {
                    clearTimeout(timer)
                }
            };
            try {
                let thumbnailUrl = await fetchThumbnail();
                if (!thumbnailUrl) {
                    await new Promise(r => setTimeout(r, 2000));
                    thumbnailUrl = await fetchThumbnail();
                }
                if (thumbnailUrl && this.files[idFile]) {
                    this.$set(this.files[idFile].info, 'enclosure', thumbnailUrl);
                }
            } catch (e) {
                console.error('error fetching video thumbnail', e);
            }
        },

        async compressMediaByNetwork(idFile, networks = []) {

            if (!this.files[idFile]) return;
           
            if (!Array.isArray(networks) || networks.length == 0) {
                networks = Object.values(this.pagesSelected).map(page => page.network);
            }
    
            const file = this.files[idFile];

            this.$set(file, 'isNormalizing', true);

            let errorNetworks = getErrorNetworkFile(file);

            for (const network of networks) {
                if (errorNetworks[network] && !file.normalizedNetworks[network]) {

                    try {
                        switch (file.info.type2) {
                          case 'image':
                            const resNormalizeImage = await withRetry(() => this.normalizeImageForNetworkStrict(file.url, network), {
                                retries: 3,
                                onRetry: (attempt, error) => {
                                    Sentry.addBreadcrumb({ category: 'upload', level: 'warning', message: `normalizeImageForNetwork retry #${attempt}`, data: { fileId: idFile, network, error: error?.message } })
                                }
                            });

                            this.$set(file.normalizedNetworks, network, {
                                url: resNormalizeImage.data.url,
                                info : {
                                    width: resNormalizeImage.data.infos.width,
                                    height: resNormalizeImage.data.infos.height,
                                    size: resNormalizeImage.data.infos.size
                                }
                            });

                            break;
                        }
                         
                    } catch (error) {
                        console.error(`Echec de la normalisation de l'image pour le réseau ${network} (idFile: ${idFile}) :`, error);
                    }
                }
                
            }

            this.$set(file, 'isNormalizing', false);
        },

        async compressAllMediasByNetwork() {
            const compressPromises = Object.keys(this.files).map(idFile => new Promise(async (resolve, reject) => {
                await this.compressMediaByNetwork(idFile);
                this.$set(this.files[idFile], 'errorNetwork', getErrorNetworkFile(this.files[idFile]));
                resolve()
            }))
                
            await Promise.all(compressPromises);
        },
    },

    computed: {
        isMongoDraftEdit() {
            return this.mode === 'edit' &&
                this.dataEditPost.post?.page?.[0]?.isDraft === true &&
                !this.dataEditPost.post?.page?.[0]?.isPgDraft
        },

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },

        isDemo() {
            return this.$store.getters['demo/isActive'];
        },

        users() {
            return this.$store.getters['users/getUsers'];
        },

        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
        }, 
        currentUser() {
            return this.$store.getters['users/getCurrentUser']
        },

        isFileUploading() {
            return Object.values(this.files).some(file => !file.isUpload && !file.failedUpload) || this.idFilesGeneratingInfo.length > 0
        },

        hasFailedUpload() {
            // isUpload:true prime sur failedUpload : un fichier déjà uploadé avec succès n'est pas "en échec",
            // même si un flag failedUpload résiduel traîne (ex. draft persisté avant le fix de la race condition
            // d'upload, ou 'error' tardif d'une connexion déjà fermée avec succès).
            return Object.values(this.files).some(file => file.failedUpload && !file.isUpload)
        },

    },

    watch: {
        async pagesSelected(newValue, oldValue) {
            if (this.mode == 'edit' && this.dataEditPost && this.dataEditPost.posts) {

                for (let i = 0; i < this.dataEditPost.posts.length; i++) {
                    const post = this.dataEditPost.posts[i];
                    if (!newValue.some(page => page.id == post.page)) {
                        this.$store.commit('selectPage/updatePagesSelected',{saveToLocalStorage: false, pagesId: oldValue.map(p => p.id)});
                        EventBus.$emit(
                            "showModal",
                            this.$t('dash.post-creator.modal.warning-title'),
                            this.$t('dash.post-creator.modal.warning-delete-scheduled'),
                            "Fermer",
                            this.$t('dash.post-creator.modal.confirm'),
                            null, 
                            "postcreator/deletePostFromClickSelectPage",
                            {
                                pageId : post.page
                            }
                        );
                    }
                  
                }
               
            }
            this.compressAllMediasByNetwork();
        },

        ['previewMode.active']: {
            immediate: true,
            handler(newValue, oldValue) {
                if (newValue) EventBus.$emit('selectPageSection/freezeSelectPage', true);   
                else EventBus.$emit('selectPageSection/freezeSelectPage', this.mode == "update");
            }
        }
    },

    beforeDestroy () {
        this.$store.commit('selectPage/updateSelectPageStoryMode', false)
        EventBus.$off('postcreator/uploadFile', this.uploadFile);
        EventBus.$off('postcreator/deletePostFromClickSelectPage', this.deletePostFromClickSelectPage);
        EventBus.$off('postcreator/forceSaveDraftBeforeReload', this.autosaveDraftToRestore);
        window.removeEventListener('beforeunload', this.autosaveDraftToRestore);

        
        switch (this.mode) {
            case "update":
                EventBus.$emit('selectPageSection/freezeSelectPage', false);    
                break;
        }
        this.$store.commit('selectPage/updateEnableAutoSave', true);
    },

    destroyed() {
        console.log('destroyed draftToRestore',  this.mode)
        this.autosaveDraftToRestore()
    },

   

}
</script>
